const getContractManagementListUrl = '/sales/requests/';

export default getContractManagementListUrl;
